export enum JobStatus {
	Created = 'created',
	Pending = 'pending',
	Finished = 'finished',
	Failed = 'failed',
}

export interface IJob {
	id: string;
	status: JobStatus;
	outputData: Record<string, any>;
}
